import React from 'react';
import {Marker, StaticMap} from 'react-map-gl';
import markerIcon from "../../images/marker.svg"
import styled from 'styled-components'

const TOKEN = "pk.eyJ1Ijoia2VtdXJvMTIiLCJhIjoiY2tvMDN1YW81MDc2ejJ1bm53ZTY2bGdrMyJ9.DJ0_bSsdjgDpaPeQ3kC6qw";

const changeMapLanguage = (map) => {
    map.getStyle().layers.forEach((layer) => {
        if (layer.id.endsWith('-label')) {
            map.setLayoutProperty(layer.id, 'text-field', [
                'coalesce',
                ['get', 'name_ru'],
                ['get', 'name'],
            ]);
        }
    });
};

const MapboxContainer = styled.div`
  width: 100%;
  height: 760px;
  margin: 50px 0px;
`

const MapBox = (props) => {
    const [viewport, setViewport] = React.useState({
        latitude: 55.739272838468295,
        longitude: 37.50776501563994,
        zoom: 15
    });

    return (
        <MapboxContainer>
            <StaticMap
                {...viewport}
                width="100%"
                height="100%"
                mapStyle="mapbox://styles/mapbox/dark-v10"
                mapboxApiAccessToken={TOKEN}
                onViewportChange={(viewport) => setViewport(viewport)}
                onStyleLoad={changeMapLanguage}
            >
                <Marker longitude={37.50776501563994} latitude={55.739272838468295}>
                    <img style={{cursor: "pointer"}} onClick={() => {
                        window.open('https://yandex.ru/maps/213/moscow/house/ulitsa_barklaya_6s5/Z04YcwdoS0cOQFtvfXtyeH5mYQ==/?ll=37.546967%2C55.742098&z=14.32', '_blank').focus();
                    }} src={markerIcon} alt={'marker'}/>
                </Marker>
            </StaticMap>
        </MapboxContainer>
    )
}

export default MapBox;
